import React, {useEffect} from 'react';
export const TERMS_URL = 'https://betareader.io/terms-of-service';
export default function TermsOfService() {
  useEffect(() => { window.location.replace(TERMS_URL); }, []);
  return <p>The current <a href={TERMS_URL}>Terms of Service</a> are on BetaReader.io.</p>;
}
